// Modernizr integration for Shopify themes
(function() {
  // Simple touch detection fallback if Modernizr fails
  function detectTouch() {
    return ('ontouchstart' in window) || 
           (window.DocumentTouch && document instanceof DocumentTouch) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0);
  }
  
  // Wait for DOM ready
  function ready(fn) {
    if (document.readyState != 'loading'){
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
  
  ready(function() {
    var html = document.documentElement;
    var classes = html.className;
    
    // Clean up any issues with classes
    classes = classes.replace(/\[object Object\]/g, '');
    classes = classes.replace(/\bno-js\b/g, 'js');
    
    // Add touch detection
    var hasTouch = (typeof Modernizr !== 'undefined' && Modernizr.touchevents !== undefined) 
                   ? Modernizr.touchevents 
                   : detectTouch();
    
    if (hasTouch) {
      classes += ' touchevents';
    } else {
      classes += ' no-touchevents';
    }
    
    // Apply cleaned up classes
    html.className = classes.trim().replace(/\s+/g, ' ');
  });
})();